/**
 * Loading Spinner component
 * Professional loading indicator with VentureOS branding
 */
import React from 'react';
import { TrendingUp, Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'md',
  fullScreen = true
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  const containerClasses = fullScreen
    ? 'min-h-screen bg-gray-50 flex flex-col items-center justify-center'
    : 'flex flex-col items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div className="text-center">
        {/* Logo */}
        <div className="flex items-center justify-center space-x-3 mb-6">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center">
            <TrendingUp className="w-6 h-6 text-white" />
          </div>
          <span className="text-2xl font-bold text-gray-900">VentureOS</span>
        </div>

        {/* Spinner */}
        <div className="flex items-center justify-center space-x-2 mb-4">
          <Loader2 className={`${sizeClasses[size]} animate-spin text-blue-600`} />
          <span className="text-gray-600 font-medium">{message}</span>
        </div>

        {/* Progress indicator */}
        <div className="w-64 bg-gray-200 rounded-full h-1">
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 h-1 rounded-full animate-pulse" style={{width: '60%'}}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;